module.exports = "/_next/static/images/mrfattypantstrans-0b3de2e90b628b50655db7df0a39d18c.png";